import React from "react";
import { Timeline as AntdTimeline } from "antd";
import type { TimelineProps as AntdTimelineProps } from "antd";

const { Item: AntdTimelineItem } = AntdTimeline;

export type TimelineProps = AntdTimelineProps;
export type TimelineItemProps = React.ComponentProps<typeof AntdTimelineItem>;

/**
 * Timeline component - display events in chronological order
 */
const Timeline: React.FC<TimelineProps> & {
  Item: typeof AntdTimelineItem;
} = (props) => {
  return <AntdTimeline {...props} />;
};

// Attach static properties
Timeline.Item = AntdTimelineItem;

export default Timeline;
